<script setup lang="ts">
const props = defineProps({
  labelText: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div :class="$style.container">
    <div v-if="labelText" :class="$style.label">
      <KeyValuePair direction="horizontal">
        <template #containerStart>
          <Icon id="history" color="--color-accent-500" size="medium" />
        </template>

        <template #containerEnd>
          <Copy type="label" size="small" color="--color-accent-500">
            {{ props.labelText.toLowerCase() }}
          </Copy>
        </template>
      </KeyValuePair>
    </div>

    <SimpleTable colorScrollbarForeground="--color-accent-300" colorScrollbarBackground="--color-white">
      <slot name="items" />
    </SimpleTable>
  </div>
</template>

<style module>
.container {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  max-height: 75vh;
  overflow: auto;
}

.label {
  display: flex;
  padding: 0 1rem;
  margin-bottom: 0.75rem;
  margin-top: 0.75rem;
}
</style>
